import React,{Component} from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,getKCISData} from '../../services/index';
import { Row, Col,Card, CardBody } from "reactstrap";

import 'antd/dist/antd.css';
import 'remixicon/fonts/remixicon.css'

import ContentLoader from 'react-content-loader'

import { connect } from "react-redux";
import { addProduct, removeProduct } from "../../services/cart/actions";
import { updateCart } from "../../services/total/actions";
import { formatPrice } from "../../helpers/formatPrice";
import HiddenCart from "../../HiddenCart";

import toast, { Toaster } from 'react-hot-toast';

import { Progress,message,Input,Affix,Tabs,Modal,Button,Select,Drawer } from 'antd';
import Pagination from "react-js-pagination";


const { Search } = Input;
const { TabPane } = Tabs;

class Index extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user_id: '',
			school_id: '',
			user_name : '',
			email : '',
			product_list : [],
			filter_category_list : [],
			selected_product_list : [],
			selected_product_name : '',
			activePage: 1,
			dataCount:'',
			active_tab:'all',
			ModelVisible:false,
			add_order_loading:false,
			show_product:false,
			steps:'1',
			type:'product',
			name : '',
			phone : '',
			selected_category:'',
			selected_sub_category:'',
			total_items:0
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id:school_id});
			this.setState({
				user_id : storedArray['data'][0]['user_id'],
				user_name : storedArray['data'][0]['user_name'],
				email : storedArray['data'][0]['email']
			});

		}
		this.checkData();
	}


	checkData(){
  	var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = localStorage.getItem("erp_id");
		var app = {user_id : user_id,page:this.state.activePage,school_id:school_id}
		getKCISData('shop/kit_list',app).then((result) => {
			let responseJson = result;
			if(responseJson){
				if(result['status'] == 200){
					this.setState({
						product_list: result['data'],
						dataCount: result['count'],
						school_id:school_id
					});
				}
			}
		});
	}

	notifyCart = () =>{
		toast.success('Item successfully added to your cart',
		  {
			style: {
			  borderRadius: '10px',
			  background: '#333',
			  color: '#fff',
			},
		  });
	}

  checkCart=()=>{

  }

	forceStateUpdate = () => {
		this.setState({ pincodemodel: false, });
		setTimeout(() => {
			this.forceUpdate();
			this.checkCart();
			if (this.state.update) {
				this.setState({ update: false,});
			} else {
				this.setState({ update: true, });
			}
		}, 100);
	};

	_getItemTotal = (item) => {
		let addonTotal = 0;
		let sum = 0;
		if (item.selectedaddons) {
			item.selectedaddons.map((addonArray) => {
				addonTotal += parseFloat(addonArray.price);
				return addonTotal;
			});
		}
		if(item.discount_price>0){
			sum += item.discount_price * item.quantity + addonTotal * item.quantity;
		}
		else{
			sum += item.base_price * item.quantity + addonTotal * item.quantity;
		}
		sum = parseFloat(sum);
		return 'Rs. ' + formatPrice(sum);
	};

	addProductQuantity = (product) => {
		const { cartProducts, updateCart } = this.props;
		let productAlreadyInCart = false;

		cartProducts.forEach((cp) => {
			if (cp.id === product.id) {
				if (JSON.stringify(cp.selectedaddons) === JSON.stringify(product.selectedaddons)) {
					cp.quantity += 1;
					productAlreadyInCart = true;
				}
			}
		});

		if (!productAlreadyInCart) {
			cartProducts.push(product);
		}
		updateCart(cartProducts);
		this.checkCart();
		//this.totalDeliveryCharge();
	}

	removeProductQuantity = (product) => {
		const { cartProducts, updateCart } = this.props;

		const index = cartProducts.findIndex(
			(p) => p.id === product.id && JSON.stringify(p) === JSON.stringify(product)
		);
		//if product is in the cart then index will be greater than 0
		if (index >= 0) {
			cartProducts.forEach((cp) => {
				if (cp.id === product.id) {
					if (JSON.stringify(cp) === JSON.stringify(product)) {
						if (cp.quantity === 1) {
							//if quantity is 1 then remove product from cart
							cartProducts.splice(index, 1);
						} else {
							//else decrement the quantity by 1
							cp.quantity -= 1;
						}
					}
				}
			});
			updateCart(cartProducts);
			//this.totalDeliveryCharge();
		}
		this.checkCart();
	}

	removeCart = (product) => {
		const { cartProducts, updateCart } = this.props;

		const index = cartProducts.findIndex(
			(p) => p.id === product.id && JSON.stringify(p) === JSON.stringify(product)
		);
		if (index >= 0) {
			cartProducts.forEach((cp) => {
				if (cp.id === product.id) {
					cartProducts.splice(index, 1);
				}
			});
			updateCart(cartProducts);
		}
		this.checkCart();
	}

	clearCart = () => {
		const { cartProducts, updateCart } = this.props;
		localStorage.removeItem('state');
		window.location.reload();
	}

	notifyStock = (msg) =>{
		toast.error(msg,
		  {
			style: {
			  borderRadius: '10px',
			  background: '#f8e302',
			  color: '#000',
			},
		  });
	}

	placeOrder=()=>{
		this.setState({add_order_loading: true});
		const { cartTotal } = this.props;
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id=storedArray['data'][0]['user_id'];
		var school_id = localStorage.getItem("erp_id");
		const { cartProducts } = this.props;

		var cary_array=Array();
		cartProducts.forEach(cp => {
			if(cp.cart_type=='Kit' && this.state.school_id==cp.school_id){
					cary_array.push({
						 id:cp.id,
						 product_id:cp.product_id,						 
						 school_id:cp.school_id,
						 cart_type:cp.cart_type,
						 user_id:cp.user_id,
						 vendor_type:cp.vendor_type,
						 product_name:cp.product_name,
						 sku_code:cp.sku_code,
						 min_quantity:cp.min_quantity,
						 max_quantity:cp.max_quantity,
						 quantity:cp.quantity,
						 image:cp.image,
						 selling_price:cp.selling_price,
						 price:cp.price,
						 product_list:cp.product_list
				 });
			}
		});
		var app = {
			user_id: user_id,
			school_id: school_id,
			address_id: '',
			cart_type: 'Kit',
			cart_data:cary_array
		}
		getKCISData('shop/order_add', app).then((result) => {
			if (result.status == 200) {
				cartProducts.length=0;
				updateCart(cartProducts);
				localStorage.setItem("state","");
				localStorage.removeItem("state");
				this.setState({
				  ModelVisible: true,
				  add_order_loading:false
				});
				this.checkCart();
			}
			if (result.status==400) {
				message.config({ top: 150});
				message.error(result.message);
			}
		});
  }

	HandleCancel = e => {
		this.setState({
		  ModelVisible: false
		});
	}

	HandleOk = e => {
		this.setState({
		  ModelVisible: false
		});
	}

	scrollTop = () =>{
	   window.scrollTo({top: 0, behavior: 'smooth'});
	};

	change_steps=(step)=>{
		if(step==5){
			this.placeOrder();
		}
		else{
			this.setState({steps: step});
		}
	}

	searchProduct = (e) => {
		this.setState({selected_category: '',activePage:1,selected_sub_category:''});
		var keyword = e.target.value;
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = localStorage.getItem("erp_id");
		var app = {
			keyword: keyword,
			user_id: user_id,
			school_id:school_id,
			page:1
		}
		getKCISData('shop/kit_list', app).then((result) => {
			let responseJson = result;
			if (responseJson.data) {
				if (result['status'] == 200) {
					this.setState({
						product_list: result['data'],
						dataCount: result['count'],
						school_id:school_id
					});
				} else {
					this.setState({
						product_list: [],
					});
				}
			}
		});
	}

	getCategory=(list)=>{
		  console.log('selected_category ',list);
			this.setState({selected_category: list.category_id,activePage:1,selected_sub_category:''});
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = localStorage.getItem("erp_id");
			var app = {user_id:user_id,category_id : list.category_id,page:1,school_id:school_id}
			getKCISData('shop/product_list_cat_id',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){
						this.setState({
							product_list: result['data'],
							dataCount: result['count']
						});
					}
				}
			});
	}

	getSubCategory=(list)=>{
			this.setState({selected_sub_category: list.sub_category_id,activePage:1,selected_category:''});
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = localStorage.getItem("erp_id");
			var app = {user_id:user_id,sub_category_id : list.sub_category_id,page:1,school_id:school_id}
			getKCISData('shop/product_list_sub_cat_id',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){
						this.setState({
							product_list: result['data'],
							dataCount: result['count']
						});
					}
				}
			});
	}

	viewProduct=(list,name)=>{
			this.setState({selected_product_list: list.product_list,show_product:true,selected_product_name:list.product_name});
	}

	handlePageChange(pageNumber) {
		this.setState({activePage: pageNumber});
		setTimeout(() => {
			this.checkData();
			this.scrollTop();
		}, 100);
	}

	onClose=()=>{
		this.setState({show_product: false});
	}

	getTotalItems=()=>{
			const { cartProducts } = this.props;
			var total=0;
			cartProducts.forEach(cp => {
				 if(cp.cart_type=='Kit' && this.state.school_id==cp.school_id){
					  total=total+1;
				 }
			});
			return total;
	}

	render()
	{
		const { cartTotal, cartProducts,addProduct, removeProduct,addProductQuantity, removeProductQuantity } = this.props;
		return (
			<div class="mobile_view home">
			   <Modal
			      title="Login"
			      visible={this.state.ModelVisible}
			      onOk={this.HandleOk}
			      onCancel={this.HandleCancel}
			      className="order-modal"
			      footer={[]}
			      >
			      <div class="col-md-12 order_model">
			         <img src="/assets/img/checked.svg" class="order_model_img"/>
			         <h2>Order Placed Successfully!</h2>
			         <p>We will inform you once your order is confirmed.</p>
			      </div>
			   </Modal>

				  <Drawer width="400" className="select-view-product" closable={true} title={this.state.selected_product_name} placement="right" onClose={this.onClose} visible={this.state.show_product}>
           <div class="cart_list right_view">
					 {this.state.selected_product_list.map((list)=> (
					   <>
							<div class="cart-item-details">
							   <div class="cart-title" dangerouslySetInnerHTML={{__html: list.sub_product_name}}></div>
							   <div>
							      <span class="cart-qty">Quantity: {list.sub_quantity}</span>
							      <span class="green-text cart-item-amount hidden"> ₹{list.sub_price_total}</span>
							   </div>
							</div>
						 </>
					 ))}
					 </div>
		      </Drawer>

			   <Toaster position="top-center" reverseOrder={false}/>
			   <div class="show-mob">
			      <HiddenCart/>
			   </div>
			   <div class="app-content content">
			      <section>

						<div class="row main_tab">
						   <div class="card-body">
						      <ul class="nav nav-tabs nav-tabs-solid">
						         <li class="nav-item"><a class="nav-link" href="/shop">Individual</a></li>
						         <li class="nav-item"><a class="nav-link  active" href="/shop_kit">Kit</a></li>
						      </ul>
						   </div>
						</div>


			         <div class="main_row rows shop_page">

			            <div class="col-lg-9 col-sm-12 col-12">
			               <div class="rows card lft mob-search">
			                  <div class="col-lg-12 col-sm-12 col-12 p_search">
			                     <Search name="order_slot" onKeyUp={this.searchProduct} onChange={this.searchProduct} placeholder="Search Kits" />
			                  </div>
			               </div>
			               <div class="rows card lft">
			                  <div class="col-lg-12 col-sm-12 col-12">
			                     <div class="frequently">Kits</div>
			                  </div>
			                  <div class="col-lg-12 col-sm-12 col-12 row irows frequently_ordered">
			                     {this.state.product_list.length>0 ? (
			                     <>
			                     {this.state.product_list.map((list)=> (
			                     <>
			                     <div class="col-lg-12 col-sm-12 col-12 cards-div">
			                        <div class="pull-left">
			                           <div class="row flex_start">
			                              <div class="pull-left">
			                                 <div class="p_img_div">
			                                    <img src={list.image} class="p_img"/>
			                                 </div>
			                              </div>
			                              <div>
			                                 <div class="capitalize"><strong>{list.product_name}</strong></div>
			                                 <div class="capitalize hidden">Price: <strong>₹{list.price}</strong></div>
			                                 <br/>
			                                 <div class="secondary-text">Total Products: {list.total_products}</div>
			                                 <div class="secondary-text">
																			 		<a href="javascript:void(0)" onClick={() => {this.viewProduct(list);}}>
																						View Products
																					</a>
																			 </div>
			                              </div>
			                           </div>
			                        </div>
			                        <div class="pull-right">
			                           {cartProducts.find((cp) => cp.id === list.id) !==undefined ? (
			                           <>
			                           <div class="cbtn">
			                              <div class="btn-group btn-group-sm qty_group woo_btn_action home_cart fright">
			                                 <button onClick={() => {removeProduct(list);this.forceStateUpdate();this.checkCart();}} type="button" class="add_cart">
			                                 <span className="btn-dec">-</span>
			                                 </button>
			                                 <span class="btn-add-remove qty">{cartProducts.find((cp) => cp.id === list.id).quantity}</span>
			                                 <button onClick={() => {addProduct(list);this.forceStateUpdate();}} type="button" class="minus_cart">
			                                 <span className="btn-inc">+</span>
			                                 </button>
			                              </div>
			                           </div>
			                           </>
			                           ) : (
			                           <div class="cbtn">
			                              <span className="hidden">{(list.quantity = 1)}</span>
			                              <button onClick={() => {addProduct(list);this.notifyCart();this.forceStateUpdate();}} type="button" class="btn btn-block addcart cbtn fright"><i class="ri-shopping-cart-line"></i> Add to Cart</button>
			                           </div>
			                           )}
			                        </div>
			                     </div>
			                     </>
			                     ))}
			                     <Pagination
			                        activePage={this.state.activePage}
			                        itemsCountPerPage={10}
			                        totalItemsCount={this.state.dataCount}
			                        pageRangeDisplayed={5}
			                        onChange={this.handlePageChange.bind(this)}
			                        />
			                     </>
			                     ) : (
			                     <> </>
			                     )}
			                  </div>
			               </div>
			            </div>
			            <div class="col-lg-3 col-sm-6 col-12 mob-hidden">
			               <div class="row">
			                  <div class="col-lg-12 col-sm-12 col-12">
			                     <>
			                     <div class="cart-table card">
			                        <div class="cart-summery">
			                           <div class="frequently">Cart
			                              <span class="clearcart"><i onClick={this.clearCart.bind(this)}  class="ri-delete-bin-line"></i></span>
			                           </div>
			                        </div>
			                        {(() => {
			                        if (cartProducts.length>0) {
			                        return (
			                        <>
			                        <div class="cart-body">
			                           <div class="desk-head">
			                              {(() => {
			                              if(this.state.steps=='2'){
			                              return (
			                              <>
			                              <div class="col-md-12 order_step2 order-summary">
			                                 <div class="row">
			                                    <div class="col-lg-12 col-sm-12 col-12">
			                                       <div class="frequently">Order Summary</div>
			                                    </div>
																					<ul class="list-group width100">
			                                       {cartProducts.map((item, index) => (
																							<>
																								{(item.cart_type=='Kit' && this.state.school_id==item.school_id) && (
																									<li class="cart-item">
		 			                                          <div class="cart-item-details">
		 			                                             <div class="cart-title">
		 			                                                {item.product_name}
		 			                                                <span class="cart-item-amount">
		 			                                                	Quantity: {item.quantity}
		 			                                                </span>
		 			                                             </div>
		 			                                          </div>
		 			                                       </li>
																								)}
																							</>
			                                       ))}
			                                    </ul>
			                                    <hr/>
			                                    <div class="place-order-button-div">
			                                       <div class="pull-left">
			                                          <div class="cart-summary-container">
			                                             <div class="secondary-text">{this.getTotalItems()} Items</div>
			                                          </div>
			                                       </div>
			                                       <div class="pull-right"></div>
			                                    </div>
			                                    <div class="place-order-button-div">
			                                       <div class="pull-left">
			                                       </div>
			                                       <div class="pull-right">
			                                          <Button onClick={this.change_steps.bind(this,'5')} type="primary" className="mybutton" loading={this.state.add_order_loading}>
			                                          Place order
			                                          </Button>
			                                       </div>
			                                    </div>
			                                 </div>
			                              </div>
			                              </>
			                              )
			                              }
			                              else{
			                              return (
			                              <>
			                              <ul class="list-group cart_list">
			                                 {cartProducts.map((item, index) => (
																				 <>
																				  {(item.cart_type=='Kit' && this.state.school_id==item.school_id) && (
																						<li class="cart-item">
 					                                    <div class="cart-item-details cart_flex">
 					                                       <div class="cart-title">
 					                                          {item.product_name}
 					                                       </div>
 					                                       <div>
 					                                          <div class="btn-group btn-group-sm cart-item-btn">
 					                                             <button
 					                                             type="button"
 					                                             className="btn-add-remove"
 					                                             style={{
 					                                             color: localStorage.getItem("cartColor-bg"),
 					                                             }}
 					                                             onClick={() => this.removeProductQuantity(item)}
 					                                             >
 					                                             <span className="btn-dec">-</span>
 					                                             </button>
 					                                             <button type="button" className="btn-quantity">
 					                                             {item.quantity}
 					                                             </button>
 					                                             <button
 					                                             type="button"
 					                                             className="btn-add-remove"
 					                                             style={{
 					                                             color: localStorage.getItem("cartColor-bg"),
 					                                             }}
 					                                             onClick={() => {
 					                                             if(item.max_quantity>cartProducts.find((cp) => cp.id === item.id).quantity){
 					                                             this.addProductQuantity(item)
 					                                             }
 					                                             else{
 					                                             this.notifyStock("Oops! Only "+item.max_quantity+" unit(s) allowed in each order");
 					                                             }
 					                                             }}
 					                                             >
 					                                             <span className="btn-inc">+</span>
 					                                             </button>
 					                                          </div>
 					                                          <span class="removecart"><i onClick={this.removeCart.bind(this,item)}  class="ri-delete-bin-line"></i></span>
 					                                       </div>
 					                                    </div>
 					                                 </li>
																	        )}
																			 </>
			                                 ))}
			                              </ul>
			                              <div class="place-order-button-div">
			                                 <div class="pull-left">
			                                    <div class="cart-summary-container">
			                                       <div class="secondary-text">{this.getTotalItems()} Items</div>
			                                    </div>
			                                 </div>
			                              </div>
			                              <div class="place-order-button-div">
			                                 <div class="pull-left">
			                                 </div>
			                                 <div class="pull-right">
			                                    <Button onClick={this.change_steps.bind(this,'2')} type="primary" className="mybutton" loading={this.state.add_order_loading}>
			                                    Continue
			                                    </Button>
			                                 </div>
			                              </div>
			                              </>
			                              )
			                              }
			                              })()}
			                           </div>
			                        </div>
			                        </>
			                        )
			                        }
			                        else {
			                        return (
			                        <div class="cart-body no_cart_div">
			                           <img src="/assets/img/no_cart.png" class="no_cart" />
			                        </div>
			                        )
			                        }
			                        })()}
			                     </div>
			                     </>
			                  </div>
			               </div>
			            </div>
			         </div>
			      </section>
			   </div>
			</div>
		)
	}
}
const mapStateToProps = (state) => ({
	cartProducts: state.cart.products,
	cartTotal: state.total.data
});

export default connect(
	mapStateToProps,
	{
		updateCart,
		addProduct,
		removeProduct
	}
)(Index);
